import { hotToast } from "utils";
import api from "../service";

export const requestTarjetaVistas = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `Admin/GetTarjetaVistas`,
    null
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};
